module.exports = __webpack_public_path__ + "img/image-juliusomo.d284b5c5.webp";